import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from '@services/config.service';
import { UserService } from '@services/user.service';
import { WebErrorService } from '@services/webError.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  fullyear = new Date().getFullYear();
  loginForm: FormGroup;
  isSubmitted = false;
  loginSpinner = false;
  submitted = false;
  userServiceSubscription$: Subscription;
  msg: any;
  private formSubmitAttempt: boolean;
  loginErrorMessage: string;
  passwordReset: any;
  lockoutMsg: boolean = false;
  constructor(private fb: FormBuilder, private userService: UserService, public configService: ConfigService,
    public translate: TranslateService, private webErrorService: WebErrorService, public router: Router) { }

  ngOnInit(): void {
    // this.styleService.addStyle('login', require('../../../scss/login.css'));
    this.loginForm = this.fb.group({
      emailId: [null,
        [Validators.required,
        Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}')
          // Validators.pattern(/^[a-zA-Z0-9]+([.]?[_]?[a-zA-Z0-9])*@[a-zA-Z0-9]+([\-\.]?[a-zA-Z0-9]+)*\.[A-Za-z]{1,3}$/)
        ]
      ]
    })
  }
  // get f(): any {
  //   return this.loginForm.controls; }

  get f() { return this.loginForm.controls; }

  reset(): any {
    this.loginErrorMessage = '';
    this.lockoutMsg = false;
    this.submitted = true;
    this.msg = '';
    if (this.loginForm.valid) {
    if(this.userServiceSubscription$){this.userServiceSubscription$.unsubscribe()}
      this.userServiceSubscription$ = this.userService.resetPassword(this.loginForm.value.emailId).subscribe(
        (data: any) => {
          this.submitted = false;
          this.passwordReset = 'true';
          localStorage.setItem('resetPassword', this.passwordReset);
          this.msg = this.translate.instant('userLogin.forgotPwd.resetPwdMsg');
          this.loginErrorMessage = '';
        }, (error: any) => { this.loginErrorMessage = error.error.message;
          if (this.loginErrorMessage.match(this.translate.instant('userLogin.loginForm.errorMsg'))) this.lockoutMsg = true; });

      // this.loginForm.reset({
      //   emailId: 'test@gmail.com'
      // });
    }
  }
  // 9006
  ngOnDestroy() {
    if(this.userServiceSubscription$){this.userServiceSubscription$.unsubscribe()}
    // this.styleService.removeStyle('login');
  }
}
